/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icons/shop-logo': {
    width: 17,
    height: 23,
    viewBox: '0 0 17 23',
    data: '<path pid="0" d="M5.684 4.365L0 5.125v14.639L11.436 23l4.747-2.05V5.414L5.684 4.365z" _fill="#000"/><path pid="1" d="M.587 5.144l5.097-.668 10.115.97-4.41 1.094L.587 5.144z" _fill="#fff"/><path pid="2" d="M2.616 5.446L2.63 3.45S2.56.54 5.124.497c2.725-.048 2.45 3.411 2.45 3.411l.005 2.172-.917-.122s.077-2.2-.013-2.946C6.525 1.996 6.002 1.377 5.18 1.38c-1.33.003-1.627 1.241-1.658 2.284-.017.583-.016 1.89-.016 1.89l-.89-.108zM8.95 4.692l-.846-.077V2.232s-.09-2.275 2.24-2.231c2.236.042 2.484 2.107 2.58 2.564.027.12.205 2.29.146 2.546 0 .01-.868-.084-.868-.084s.055-2.136-.328-3.138c-.265-.695-1.017-1.12-1.798-1.05-.78.068-.997.768-.997.768s-.13.32-.106.967c.002.067-.024 2.118-.024 2.118z" _fill="#000"/>'
  }
})
